import React from 'react';
import './FinalCTA.scss';

const FinalCTA: React.FC = () => {
  const handleGetStarted = () => {
    window.open('https://shadow-16723594.myshopify.com/products/shadow-tracker', '_blank');
  };

  return (
    <section className="final-cta">
      <div className="container">
        <div className="cta-content">
          <h2>Ready to Protect Your Assets?</h2>
          <p>Join thousands of satisfied customers who trust Shadow Tracker to keep their valuables safe</p>
          <div className="cta-buttons">
            <button className="btn-primary" onClick={handleGetStarted}>
              Get Started Now
            </button>
            <button className="btn-secondary" onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}>
              View Pricing
            </button>
          </div>
          <div className="cta-guarantee">
            <span className="guarantee-icon">✓</span>
            <span>30-Day Money-Back Guarantee • No Questions Asked</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
